import { PaginatedColumn } from "../types/app";
import { CompanyRequest, CompanyRequestTouched } from "../types/companies";

export const COMPANIES_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: "Nombre",
    key: "name",
  },
  {
    label: "Razón social",
    key: "socialReason",
    flex: 1,
  },
  {
    label: "Activo",
    key: "active",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    label: "Actions",
    key: "actions",
    centered: true,
    minWidth: 100,
    maxWidth: 100,
  },
];

export const COMPANY_DEFAULTS: CompanyRequest = {
  name: "",
};

export const COMPANY_TOUCHED_DEFAULTS: CompanyRequestTouched = {
  nameTouched: false,
};
